export default () => {

  const errors = {};

  return errors;
  
}